import { render, staticRenderFns } from "./TeacherScheduleItem.vue?vue&type=template&id=28c46c1f&scoped=true&"
import script from "./TeacherScheduleItem.vue?vue&type=script&lang=js&"
export * from "./TeacherScheduleItem.vue?vue&type=script&lang=js&"
import style0 from "./TeacherScheduleItem.vue?vue&type=style&index=0&id=28c46c1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c46c1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDivider,VIcon,VTooltip})
